package fyi.moko.hotpl.ui.util

import kotlin.math.max
import kotlin.math.min

/** Visit count at which the card glow saturates; more visits change nothing further. */
const val VISIT_GLOW_CAP = 10

/**
 * Deterministic 0f..1f "how often I come here" fraction for the card-background glow
 * (PROJECT.md §4-⑥: frequency felt as temperature, not read as a number). 1 visit → 0f,
 * i.e. the baseline card tone, so the separation we rely on is never lost; a place gets
 * *warmer* only as it's revisited, capping at [VISIT_GLOW_CAP]. Never random — the glow
 * is my visit history, nothing else.
 */
fun visitGlowFraction(visitCount: Int): Float {
    val clamped = min(max(visitCount, 1), VISIT_GLOW_CAP)
    return (clamped - 1).toFloat() / (VISIT_GLOW_CAP - 1)
}
